<template>
  <div>
    <div>
      <v-form v-model="isValid">
        <v-container class="compact">
          <v-card v-show="showDetail">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="2" sm="2" md="1">
                    <v-text-field v-model="editedItem.id" label="ID" disabled></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="3" md="2">
                    <v-text-field v-model="editedItem.host.clubName" label="Host" :disabled=dis()></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="5" md="3">
                    <v-text-field v-model="editedItem.trialName" :rules="[v => !!v || 'Name is required']"
                                  label="Name" :disabled=blockEdit()></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-select v-model="editedItem.type" :rules="[v => !!v || 'Type is required']"
                              label="Type" :items="$itmStore.trialTypes" :disabled=blockEdit()></v-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-text-field v-model="editedItem.city" :rules="[v => !!v || 'City is required']"
                                  label="City" :disabled=blockEdit()></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2" md="1">
                    <v-select v-model="editedItem.state" :items="this.$itmStore.states" label="State" :rules="[
                      v => !!v || 'State is required',
                      v => (v && v.length >= 2) || 'State must have 2+ characters'
                    ]" :disabled=blockEdit()></v-select>
                  </v-col>
                  <v-col cols="12" sm="2" md="1">
                    <v-text-field v-model="editedItem.postalCode" :disabled=blockEdit()
                                  :rules="[v => !!v || 'Postal Code is required']"
                                  label="Postal"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="2" md="1">
                    <v-text-field v-model="editedItem.maxRuns" label="Team Limit" :disabled=blockEdit()></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2" md="1">
                    <v-text-field v-model="editedItem.regFee" label="Reg. Fee" :disabled=blockEdit()></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-select v-model="editedItem.idCo" label="C.O." :disabled=blockEdit() :items="coList"></v-select>
                  </v-col>

                  <v-col cols="12" sm="3" md="2">
                    <v-select v-model="editedItem.judge[0].id" label="Judge 1" :disabled=blockEdit()
                              :items="judgeList"></v-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-select v-model="editedItem.judge[1].id" label="Judge 2" :disabled=blockEdit()
                              :items="judgeList"></v-select>
                  </v-col>

                  <v-col cols="12" sm="3" md="2" v-if="editedItem.judge[2]">
                    <v-text-field
                        active="true"
                        v-model="editedItem.judge[2].fullName"
                        label="Judge"
                        :disabled=blockEdit()
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2" v-show="mayEdit">
                    <v-text-field
                        v-model="editedItem.premium"
                        label="Payment link"
                        :readonly=blockEdit()
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-show="mayEdit">
                  <v-col cols="12" sm="3" md="2">
                    <DateField :rcvd-date="editedItem.startDate" :itm-key="editedItem.id.toString()"
                               @datechanged="strtDate" lbl="Trial date" :disabled=blockEdit()>
                    </DateField>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <DateField :rcvd-date="editedItem.pubDate" :itm-key="editedItem.id.toString()"
                               @datechanged="publDate" lbl="Publ date" :disabled=blockEdit()>
                    </DateField>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <DateField :rcvd-date="editedItem.openDate" :itm-key="editedItem.id.toString()"
                               @datechanged="opnDate" lbl="Open date" :disabled=blockEdit()>
                    </DateField>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <DateField :rcvd-date="editedItem.drawDate" :itm-key="editedItem.id.toString()"
                               @datechanged="drwDate" lbl="Draw date" :disabled=blockEdit()>
                    </DateField>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <DateField :rcvd-date="editedItem.closeDate" :itm-key="editedItem.id.toString()"
                               @datechanged="clsDate" lbl="Close date" :disabled=blockEdit()>
                    </DateField>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-checkbox v-model="editedItem.active" :disabled=blockEdit() label="active">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-show="!mayEdit">
                  <v-col cols="12" sm="3" md="2">Trial date: {{ tDate }}</v-col>
                  <v-col cols="12" sm="3" md="2">Publ date: {{ pDate }}</v-col>
                  <v-col cols="12" sm="3" md="2">Open date: {{ oDate }}</v-col>
                  <v-col cols="12" sm="3" md="2">Draw date: {{ dDate }}</v-col>
                  <v-col cols="12" sm="3" md="2">Close date: {{ cDate }}</v-col>
                  <v-col cols="12" sm="3" md="2">Close date: {{ cDate }}</v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="regs">Registrations</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="vols">Volunteers</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="runorder">Run Order</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="scoresht">Score cards</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="mastersht">Master Sheet</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="mastercheck">Master Check</v-btn>
              <v-btn color="blue darken-1" v-show="showRegs" text @click="doExport">SRL File</v-btn>
              <v-btn color="blue darken-1" text @click="results">Results</v-btn>
              <v-btn color="blue darken-1" text :href="editedItem.premium" v-show="showPmtLink">Pay</v-btn>
            </v-card-actions>

            <v-card-actions>
              <v-file-input v-show="allowUpload"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                  label="Upload results file"
                  @change="pickedFile"
                  full-width
              ></v-file-input>

              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="reset" :disabled="!isChanged" v-show="mayEdit">Reset</v-btn>
              <v-btn color="blue darken-1" text @click="close">Close</v-btn>
              <v-btn color="blue darken-1" text v-show="mayEdit" :disabled="!maySave" @click="saveTrial">Save</v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-show="showEntries">
            So far, {{ vollies.length }} volunteers, {{ extendedInfo[0].entries.length }} competitors for this trial:
            <v-data-table
                :headers="headers"
                :items="extendedInfo[0].entries"
                :items-per-page="15"
                class="elevation-1"
            >
              <template v-slot:item.team.member.fullName="{ item }">
                {{ item.team.member.mNbr }} {{ ' ' }} {{ item.team.member.fullName }}
              </template>
              <template v-slot:item.team.dog.callName="{ item }">
                {{ item.team.dog.kNbr }} {{ ' ' }} {{ item.team.dog.callName }}
              </template>
              <template v-slot:item.team.member.phone="{ item }">
                {{ item.team.member.phone }} {{ '/' }} {{ item.team.member.email }}
              </template>
              <template v-slot:item.status="{ item }">
                {{ item.status }} {{ ', rank: ' }} {{ item.wlRank }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    @click="deleteEntry(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="exportRegs">Export to Excel</v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-show="showResults">
            <v-data-table
                :headers="resHeaders"
                :items="result"
                :items-per-page="15"
                class="elevation-1"
            >
              <template v-slot:item.placement="{ item }">
                {{ item.placement }}
              </template>
              <template v-slot:item.member.fullName="{ item }">
                {{ item.team.member.fullName }}
              </template>
              <template v-slot:item.dog.callName="{ item }">
                {{ item.team.dog.callName }}
              </template>
              <template v-slot:item.points="{ item }">
                {{ item.points/1000 }}
              </template>
              <template v-slot:item.faults="{ item }">
                {{ item.faults }}
              </template>
              <template v-slot:item.time="{ item }">
                {{ $centiSec2txt(item.time) }}
              </template>
              <template v-slot:item.title="{ item }">
                {{ item.title }}
              </template>
            </v-data-table>
          </v-card>
          <v-card v-show="showVols">
            So far, {{ vollies.length }} volunteers for this trial:
            <v-data-table
                :headers="volHeaders"
                :items="vollies"
                :items-per-page="15"
                class="elevation-1"
            >
              <template v-slot:item.member.fullName="{ item }">
                {{ item.member.mNbr }} {{ ' ' }} {{ item.member.fullName }}
              </template>
              <template v-slot:item.avail="{ item }">
                {{ item.availability }}
              </template>
              <template v-slot:item.butNot="{ item }">
                {{ item.cannot }}
              </template>
              <template v-slot:item.cmnt="{ item }">
                {{ item.cmnt }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    @click="deleteVollie(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          <v-card-actions>
          <v-btn color="blue darken-1" text @click="exportVollies">Export to Excel</v-btn>
          </v-card-actions>
          </v-card>
        </v-container>
      </v-form>
    </div>
    <div id="dummy">
      <iframe id="dummy_frame" style="display:none;"></iframe>
    </div>
  </div>
</template>

<script>
import DateField from './DateField'

export default {
  name: "TrialDetail",
  components: {
    DateField
  },
  watch: {
    trial(newTrial) {
      console.log('watch->newTrial')
      console.log(newTrial)
      if (newTrial) {
        this.result = []
        this.showResults = false
        this.savedTrial = JSON.stringify(newTrial, 3)
        this.editedItem = Object.assign(this.editedItem, this.trial)
        if (this.editedItem.judge.length < 2)
          this.editedItem.judge.push({id: null})
        if (this.editedItem.judge.length < 2)
          this.editedItem.judge.push({id: null})
//        this.editedItem.judge[0]={'id': this.editeItem.judge[0].id}
        this.getExtendedInfo(newTrial.id)
        if (this.coList.length < 1) {
          this.loadCOList()
        }
        if (this.judgeList.length < 1) {
          this.loadJudgeList()
        }
        this.initItem = Object.assign(this.initItem, this.editedItem)
        this.mayEdit = false
        this.isClubRep = false
        if (this.$usrStore.id == this.trial.host.clubRep) {
          this.isClubRep = true
          this.mayEdit = true
          if (this.trial.pubDate == null) {
            this.mayEdit = true
          }
        }
        if (this.$hasRole(['adm', 'sys'])) {
          this.mayEdit = true
        }
      } else {
        this.savedTrial = ''
        this.editedItem = Object.assign(this.editedItem, this.defaultItem)
      }
    },
  },
  props: {
    trial: {
      type: Object,
      default: () => {
      }
    },
  },
  data: () => ({
    volHeaders: [
      {text: 'Volunteer', value: "member.fullName", sortable: true, align: 'start'},
      {text: 'Available', value: "avail"},
      {text: 'Unable to do:', value: "butNot"},
      {text: 'Comments', value: "cmnt"},
      {text: 'Actions', value: 'actions', sortable: false},
    ],

    resHeaders: [
      {text: 'Place', value: "placement", sortable: true, align: 'start'},
      {text: 'Handler', value: "member.fullName"},
      {text: 'Dog', value: "dog.callName"},
      {text: 'Points', value: "points"},
      {text: 'Time', value: "time"},
      {text: 'Faults', value: "faults"},
      {text: 'Title', value: "title"},
    ],

    headers: [
      {text: 'Handler', value: "team.member.fullName", sortable: true, align: 'start'},
      {text: 'Contact', value: 'team.member.phone'},
      {text: 'Dog', value: 'team.dog.callName'},
      {text: 'Breed', value: 'team.dog.breed'},
      {text: 'Status', value: 'status'},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    vollies: [],
    judgeList: [],
    coList: [],
    fn: '',
    showDetail: true,
    showEntries: false,
    showVols: false,
    showResults: false,
    mayEdit: false,
    isClubRep: true,
    isValid: true,
    savedTrial: '',
    extendedInfo: [{'entries': []}],
    result: [],
    editedItem: {
      id: '',
      host: '',
      name: '',
      type: '',
      city: '',
      idCo: '',
      location: '',
      trialName: '',
      startDate: '',
      openDate: '',
      pubDate: '',
      closeDate: '',
      drawDate: '',
      postalCode: '',
      maxRuns: '',
      regFee: '',
      extra: {},
      premium: '',
      judge: [
        {id: null},
        {id: null},
      ],
    },
    defaultItem: {
      id: '',
      host: '',
      name: '',
      type: '',
      city: '',
      idCo: '',
      location: '',
      trialName: '',
      startDate: '',
      openDate: '',
      pubDate: '',
      closeDate: '',
      drawDate: '',
      postalCode: '',
      maxRuns: '',
      regFee: '',
      extra: {},
      premium: '',
      judge: [
        {id: null},
        {id: null},
      ],
    },
    initItem: {}
  }),
  computed: {
    tDate: {
      get() {
        return this.$iso2AU(this.trial.startDate)
      },
    },
    oDate() {
      return this.$iso2AU(this.trial.openDate)
    },
    pDate() {
      return this.$iso2AU(this.editedItem.pubDate)
    },
    dDate() {
      return this.$iso2AU(this.editedItem.drawDate)
    },
    cDate() {
      return this.$iso2AU(this.editedItem.closeDate)
    },
    formTitle() {
      if (this.mayEdit) {
        return this.trial.id === null ? 'Add Trial' : `Edit ${this.trial.type + ' ' + this.trial.city + '/' + this.trial.state + ' ' + this.trial.trialName}`
      } else {
        return `${this.trial.type + ' ' + this.trial.city + '/' + this.trial.state + ' ' + this.trial.trialName}`
      }
    },
    showRegs() {
      return this.mayEdit || this.isClubRep
    },
    allowUpload() {
      if(new Date().valueOf() < new Date(this.editedItem.startDate).valueOf()) {
        return false
      } else {
        return this.mayEdit || this.isClubRep
      }
    },
    showPmtLink() {
      if(!this.editedItem.premium) return false
      if(new Date().valueOf() < new Date(this.editedItem.startDate).valueOf()) {
        if(this.editedItem.premium.substring(0,8).toLowerCase()=='https://') {
          return true
        }
      }
      return false
    },
    isChanged() {
      return JSON.stringify(this.editedItem) !== JSON.stringify(this.initItem)
    },
    maySave() {
      return true
//      return (JSON.stringify(this.editedItem) !== JSON.stringify(this.initItem)) && this.isValid
    }
  },
  mounted: function () {
    console.log('TrialDetail mounted')
    this.editedItem = Object.assign(this.editedItem, this.trial)
    //this.savedTrial = Object.assign({}, this.trial)
    this.savedTrial = JSON.stringify(this.trial)
  },
  methods: {
    deleteEntry(item) {
      if(window.confirm('Do you really want to delete this entry?')){
        alert(`Cancel ${item.team.member.fullName}`)
        let theToken = localStorage.getItem('token')
        if (theToken == null) {
          // alert('You must log in to access this feature')
          this.$router.push('/')
        }
        this.error = this.jsdoc = null
        this.loading = true

        this.$http.post(this.$remote + '/api.trial/cancelreg', {
          token: theToken, entryId: item.id
        })
            .then(response => {
              this.$usrStore.token = response.data.token
              localStorage.setItem('token', response.data.token)
              if(response.status>289){
                alert(response.data.msg)
              } else {
                this.getExtendedInfo(this.trial.id)
              }
              this.loading = false
            })
            .catch(function (err) {
                  if (err.response.data) {
                    alert(err.response.data.msg)
                  } else {
                    alert(err)
                  }
                }
            )

      }
    },
    deleteVollie(item) {
      if(window.confirm('Do you really want to delete this volunteer entry?')){
        alert(`Cancel ${item.member.fullName}`)
        let theToken = localStorage.getItem('token')
        if (theToken == null) {
          this.$router.push('/')
        }
        this.error = this.jsdoc = null
        this.loading = true

        this.$http.post(this.$remote + '/api.trial/cancelvollie', {
          token: theToken, volId: item.id
        })
            .then(response => {
              this.$usrStore.token = response.data.token
              localStorage.setItem('token', response.data.token)
              if(response.status>289){
                alert(response.data.msg)
              } else {
                this.getExtendedInfo(this.trial.id)
              }
              this.loading = false
            })
            .catch(function (err) {
                  if (err.response.data) {
                    alert(err.response.data.msg)
                  } else {
                    alert(err)
                  }
                }
            )

      }
    },
    fileUpload: function (file) {
      const reader = new FileReader();
      const URL = this.$remote + "/w3/file"
      const evtId = this.trial.id
      const evtType = this.trial.type
      // const poster = this.$http
      reader.addEventListener("loadend", function () {
        let formData = new FormData();
        formData.append("fileName", file.name)
        formData.append("use", "event-result")
        formData.append("eventId", evtId)
        formData.append("eventType", evtType)
        formData.append("content", btoa(reader.result));
        // const resp = fetch(URL, {method: 'POST', body: formData, 'Content-Type': 'multipart/form-data'});
        // const resp = await fetch(URL, {method: 'POST', body: formData, 'Content-Type': 'multipart/form-data'});
        // console.log(resp.json())
        fetch(URL, {method: 'POST', body: formData, 'Content-Type': 'multipart/form-data'})
        .then(response => response.json())
        .then( data => {
          console.log(data.Log)
          // alert(data.Log)
          let log = "RESULTS UPDATE LOG:\n"
          for (let i=0; i< data.Log.length; i++) {
            log = log + "\n"+data.Log[i]
          }
          alert(log)
        })
      })
      reader.readAsBinaryString(file);
    },
    pickedFile(file) {
      console.log(file)
      this.fileUpload(file)
    },
    register() {
      this.$emit("showTrialReg", this.item)
    },
    regs: function () {
      if (!this.showEntries) {
        this.showEntries = true
        this.showVols = false
      } else {
        this.showEntries = false
      }
    },
    vols: function () {
      if (!this.showVols) {
        this.loadVollies(this.trial.id)
        this.showVols = true
        this.showEntries = false
      } else {
        this.showVols = false
      }
    },
    results: function () {
      this.showResults = !this.showResults
      if (this.showResults) {
        this.loadResult(this.trial.id)
      }
    },
    blockEdit: function () {
      return !this.mayEdit
    },
    scoresht: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/ortsheet', {
        token: theToken, trialId: this.trial.id
      })
          .then(response => {
            console.log('Got response from ortsheet')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    mastersht: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/mastersheet', {
        token: theToken, trialId: this.trial.id, mode: 'judge'
      })
          .then(response => {
            console.log('Got response from mastersheet')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    mastercheck: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/mastersheet', {
        token: theToken, trialId: this.trial.id, mode: 'checkin'
      })
          .then(response => {
            console.log('Got response from ortsheet')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
   exportVollies: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/volxlsx', {
        token: theToken, trialId: this.trial.id
      })
          .then(response => {
            console.log('Got response from srlfile')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    exportRegs: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/regxlsx', {
        token: theToken, trialId: this.trial.id
      })
          .then(response => {
            console.log('Got response from regsfile')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },

    doExport: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/srlfile', {
        token: theToken, trialId: this.trial.id
      })
          .then(response => {
            console.log('Got response from srlfile')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    runorder: function () {
      this.showEntries = false
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.$http.post(this.$remote + '/api.trial/runorder', {
        token: theToken, trialId: this.trial.id
      })
          .then(response => {
            console.log('Got response from runorder')
            this.fn = response.data.file
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            let url = this.$remote + '/' + this.fn
            document.getElementById('dummy_frame').src = url
/*
            url = this.$remote + '/' + response.data.file
            let link = document.createElement('a');
            link.href = url;
            link.target = '_blank'
            link.download = response.data.pdf;
            link.dispatchEvent(new MouseEvent('click'));
*/
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    getExtendedInfo: function (id) {
      this.loadTrial(id)
      this.loadVollies(id)
    },
    loadVollies: function (id) {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/list_vollies', {
        token: theToken, trialId: id
      })
          .then(response => {
            console.log('Got response from list_vollies')
            this.vollies = response.data.vollies
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadResult: function (id) {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trial_result', {
        token: theToken, trialId: id
      })
          .then(response => {
            console.log('Got response from trial_result')
            this.result = response.data.result
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadTrial: function (id) {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trial_detail', {
        token: theToken, trialId: id
      })
          .then(response => {
            console.log('Got response from trial_detail')
            this.extendedInfo = response.data.trials
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
            this.result = []
            this.showResults = false

          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    saveTrial: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        this.$router.push('/')
      }
      const response = await this.$http.post(this.$remote + '/api.trial/updtrial', {
        token: theToken, trialData: JSON.stringify(this.editedItem)
      })
      this.$usrStore.token = response.data.token
      //this.$emit('endTrialDetail', this.editedItem)
      alert('Saved')
      this.$emit('refreshTrials', response.data.updated)
      this.$emit('reloadTrials')
    },
    loadCOList: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      const response = await this.$http.post(this.$remote + '/api/mbrwrole', {
        token: theToken, role: 'CO'
      })
      this.$usrStore.token = response.data.token
      this.coList = response.data.mbrs
    },
    loadJudgeList: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      const response = await this.$http.post(this.$remote + '/api/mbrwrole', {
        token: theToken, role: 'Judge'
      })
      this.$usrStore.token = response.data.token
      this.judgeList = response.data.mbrs
    },
    dis() {
      return !this.allowOwnerChange
    },
    strtDate: function (event) {
      this.editedItem.startDate = event
    },
    publDate: function (event) {
      this.editedItem.pubDate = event
    },
    opnDate: function (event) {
      this.editedItem.openDate = event
    },
    drwDate: function (event) {
      this.editedItem.drawDate = event
    },
    clsDate: function (event) {
      this.editedItem.closeDate = event
    },
    close: function () {
      try {
        this.editedItem = JSON.parse(this.savedTrial)
      } finally {
        this.$emit('endTrialDetail', null)
      }
    },
    reset() {
      this.editedItem = Object.assign(this.editedItem, this.initItem)
    },
  }
}
</script>

<style scoped>

</style>
